import { SiteUrls } from '@tableau/shared-urls';

import { Module } from '../Module';
import { IWorkbookRevision } from '../ServerApi/types/IContentRevision';
import { ServerService } from '../services/ServerService';
import { WindowLocationService } from './WindowLocationService';

export class PreviewWorkbookRevisionAction {

  public static $inject = ['ServerService',
                           'WindowLocationService'];

  constructor(
    private serverService: ServerService,
    private windowLocationService: WindowLocationService) { }

  public openPreview(revision: IWorkbookRevision) {
    const siteUrls = new SiteUrls({siteUrlName: this.serverService.sessionSiteUrlName(), queryString: window.location.search});
    this.windowLocationService.open(siteUrls.workbookRevisionPreviewUrl(revision.revisionPath));
  }

}

Module.instance().service('PreviewWorkbookRevisionAction', PreviewWorkbookRevisionAction);
